import ErrorBoundary from 'dashboard-components/error/ErrorBoundary';
import { SentryEventIds } from 'dashboard-lib/public/sentry';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportingActionsErrorBoundary = props => {
  const ErrorComponent = () => /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.action.errorBoundaryMessage"
    })
  });
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    name: SentryEventIds.REPORTING_ACTIONS_LOADER_ERROR_BOUNDARY,
    ErrorComponent: ErrorComponent,
    children: props.children
  });
};